import { useUpdateLogoBackingMutation } from 'modules/organizer/store/logo-backing-api';
import { useCallback } from 'react';
import { Background, backgroundColors } from 'shared/constants/backgrounds';

export interface UpdateLogoBackgroundParams {
  bgColor?: Background;
  tournamentId?: number;
}

/** Ключ `backgroundColors` по значению цвета; `undefined` — такого цвета в наборе нет. */
function findBackgroundType(bgColor: Background): number | undefined {
  for (const [key, value] of Object.entries(backgroundColors)) {
    if (value.value === bgColor.value) {
      const parsed = parseInt(key, 10);
      return Number.isNaN(parsed) ? undefined : parsed;
    }
  }
  return undefined;
}

/**
 * Сохраняет фон логотипа организатора; ответ сразу ложится в кэш `useFetchLogoBackground`
 * (`logo-backing-api.ts`). Позволяет запускать операцию параллельно с апсертом организатора.
 *
 * Возвращает сохранённую строку, `null` при сбое записи и `false`, если сохранять нечего.
 */
export function useUpdateLogoBackground() {
  const [updateLogoBacking] = useUpdateLogoBackingMutation();

  const updateLogoBackground = useCallback(
    async (params: UpdateLogoBackgroundParams) => {
      const { bgColor, tournamentId } = params;
      if (!bgColor || !tournamentId) return false;

      const backgroundType = findBackgroundType(bgColor);
      if (backgroundType === undefined) return false;

      return updateLogoBacking({ organizerId: tournamentId, type: backgroundType }).unwrap();
    },
    [updateLogoBacking],
  );

  return { updateLogoBackground };
}
